<template>
  <MovieDetails />
</template>

<script>
import MovieDetails from "@/components/MovieDetails.vue";

export default {
  name: "Movie",
  components: {
    MovieDetails
  }
};
</script>
